import { availabilityApi, contentApi } from '@/infrastructure/Configuration'
import Hotel from '../domain/Hotel'
import NewMapper from './NewMapper'
import ExternalStorage from '@/services/ExternalStorage'
import { hotelStayDatesFactory } from '@/multi-room-display/infrastructure/Factory'
import { DateFactory } from 'rhg-vue-common'
import { redirect } from '@/infrastructure/Utils'
// import mockPrueba from '../services/mockprueba.json'
export default class NewRdHotelService {
  constructor(httpClient) {
    this.httpClient = httpClient
    this.defaultCurrency = 'EUR'
  }

  async getHotel(hotelCode) {
    const url = `${contentApi}/hotels/${hotelCode}`
    const {
      data: { hotel }
    } = await this.httpClient.get(url)
    return hotel
  }

  async getRooms(hotelCode) {
    const url = `${contentApi}/hotels/${hotelCode}/rooms`
    const {
      data: { rooms }
    } = await this.httpClient.get(url)
    return rooms
  }

  async getStays(
    customer,
    jsonHotel,
    jsonRooms,
    queryParams,
    taxIncludedRegion,
    taxExcludedRegion,
    preselectedFilters,
    currentSelectedRoom
  ) {
    const { checkInDate, checkOutDate } = hotelStayDatesFactory.create(queryParams)
    const occupancies = queryParams.adults.map((adultCount, roomIndex) => {
      const adults = parseInt(adultCount)
      const childrenAges = ((queryParams.aoc && queryParams.aoc[roomIndex]) || '').split(',')
      const children =
        childrenAges.length > 0 && childrenAges[0] !== '' && childrenAges[0] !== 'NaN'
          ? childrenAges.map(age => ({ age: parseInt(age) }))
          : []
      return {
        adults,
        children
      }
    })
    queryParams = {
      ...queryParams,
      checkInDate: DateFactory.formatDate(DateFactory.dateObject(checkInDate)),
      checkOutDate: DateFactory.formatDate(DateFactory.dateObject(checkOutDate)),
      occupancies,
      taxIncludedRegion:
        (taxIncludedRegion ? true : undefined) || (taxExcludedRegion ? false : undefined),
      roomIds: [
        ...new Set(
          jsonRooms.reduce(
            (acc, currRoom) =>
              currRoom.tmsCode ? [...acc, currRoom.tmsCode, currRoom.id] : [...acc, currRoom.id],
            []
          )
        )
      ],
      sourceOfBusiness: ExternalStorage.global.sourceOfBusiness(),
      groupedStays: true,
      voucherCode: queryParams.voucher || undefined,
      aoc: undefined,
      adults: undefined,
      children: undefined,
      room: undefined
    }
    if (customer.isLogged) {
      const isTier = !!(
        jsonHotel.tierDiscount &&
        queryParams.searchType === 'lowest' /* SearchTypes.LOWEST */ &&
        customer.tier
      )
      queryParams = isTier
        ? {
          ...queryParams,
          tierDiscount: {
            tierType: customer.tier
          }
        }
        : { ...queryParams }
    }

    const transactionId = ExternalStorage.session.transactionId()
    const saverHeader = (localStorage.getItem('saver') || 'true') === 'true'
    const preferredCurrency = global.Cookie.read(window.cookieDictionary.preferredCurrency)

    const config = {
      headers: {
        Saver: saverHeader,
        transactionId,
        'X-Currency': preferredCurrency || 'EUR'
      }
    }

    !transactionId && delete config.headers.transactionId
    !saverHeader && delete config.headers.Saver
    delete queryParams.voucher
    try {
      return await this.getStaysByRooms(
        queryParams,
        config,
        jsonHotel,
        jsonRooms,
        preselectedFilters,
        currentSelectedRoom,
        customer
      )
    } catch (error) {
      if (error && error.response && error.response.status === 428) {
        const timeoutError428 = global.ConfigDynamic.valueOf({
          key: 'error.428.timeout',
          defaultValue: '0'
        })
        if (timeoutError428 > 0) {
          return await new Promise((resolve, reject) => {
            setTimeout(() => {
              redirect(window.location.href, {})
            }, timeoutError428)
          })
        }
      }
      return Promise.reject(error)
    }
  }

  async getStaysByRooms(
    queryParams,
    config,
    jsonHotel,
    jsonRooms,
    preselectedFilters,
    currentSelectedRoom,
    customer
  ) {
    const paramsToSend = { ...queryParams, ...customer }
    if (!customer.promotionCode && queryParams.promotionCode) {
      paramsToSend.promotionCode = queryParams.promotionCode
    }
    if (
      customer.profileType &&
      (customer.profileType.includes('PCR') || customer.profileType.includes('TMC')) &&
      global.Cookie.read('r4uActive') !== 'corporate' &&
      !queryParams.promotionCode
    ) {
      delete paramsToSend.promotionCode
    }
    const response = await this.httpClient.post(
      `${availabilityApi}/stays-by-rooms`,
      paramsToSend,
      config
    )

    const json = response.data
    // const json = mockPrueba

    ExternalStorage.session.saveTravelAgencyCustomerId(json.customerId)
    ExternalStorage.session.savePromotionalCodeGroupId(json.groupId)

    return NewMapper.fromJson({
      jsonHotel: jsonHotel,
      jsonRooms: jsonRooms,
      jsonStaysByRooms: json.rooms,
      minNightsPerStay: json.minNightsPerStay,
      hotelCurrency: json.currency,
      payUponArrival: json.payUponArrival,
      searchApplicable: json.searchApplicable,
      matchesSearch: json.matchesSearch,
      freeUpgradeBB: json.freeUpgradeBB,
      employeeAndHasNotTeamRatesAvailable: json.employeeAndHasNotTeamRatesAvailable,
      searchType: queryParams.searchType,
      preselectedFilters,
      currentSelectedRoom
    }).toDomain()
  }

  async getCurrency(currency) {
    const exchangeRatesStorage = global.UtilsCurrency.getCurrenciesInSessionStorage(currency)
    let exchangeRatesList = []
    if (!exchangeRatesStorage || exchangeRatesStorage.length === 0) {
      const url = `${availabilityApi}/exchange-rates/${this.defaultCurrency}`
      const {
        data: { exchangeRates }
      } = await this.httpClient.get(url)
      global.UtilsCurrency.setCurrenciesInSessionStorage(exchangeRates)
      exchangeRatesList = exchangeRates
    } else {
      exchangeRatesList = exchangeRatesStorage
    }
    return exchangeRatesList
  }

  async getNearbyHotels(hotelCode) {
    const preferredCurrency = global.Cookie.read(window.cookieDictionary.preferredCurrency)

    const config = {
      headers: {
        'X-Currency': preferredCurrency || 'EUR'
      }
    }

    const url = `${contentApi}/hotels/${hotelCode}/nearby-hotels`
    const {
      data: { nearbyHotels }
    } = await this.httpClient.get(url, config)
    return (nearbyHotels || []).map(it => Hotel.fromJSON(it))
  }

  async getExternalHotels() {
    const url = `${contentApi}/hotels-external`
    const {
      data: { hotels }
    } = await this.httpClient.get(url)
    return hotels
  }

  async getCoBrandImage(coBrandKey) {
    if (!coBrandKey) return null

    const params = { coBrandKeys: coBrandKey }
    const url = `${contentApi}/hotels/cobrands/images`

    const { data } = await this.httpClient.get(url, { params })

    if (!data.images.length) return null

    return data.images[0]
  }

  async getAvailabilityPriceMatch(requestData) {
    const {
      hotelCode,
      price,
      priceWithTax,
      occupancies,
      checkIn,
      checkOut,
      country,
      device,
      identifier
    } = requestData

    const url = `${availabilityApi}/price-match`

    const payload = {
      hotelCode,
      price,
      priceWithTax,
      occupancies,
      checkIn,
      checkOut,
      country,
      device,
      identifier
    }

    const preferredCurrency = global.Cookie.read(window.cookieDictionary.preferredCurrency)
    const transactionId = ExternalStorage.session.transactionId()

    const config = {
      headers: {
        'X-Currency': preferredCurrency || 'EUR'
      }
    }

    if (transactionId) {
      config.headers.transactionId = transactionId
    }

    const { data } = await this.httpClient.post(url, payload, config)
    return data
  }

  async getPriceMatchModal() {
    const url = `${contentApi}/price-match/modal`
    const {
      data: { priceMatchModal }
    } = await this.httpClient.get(url)
    return priceMatchModal
  }
}
